import { IonButton, IonContent, IonIcon, IonPage } from '@ionic/react';
import { refreshOutline } from 'ionicons/icons';
import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import LibrarySummaryStep from '../../components/wizard/steps/LibrarySummaryStep';
import { useLibraryStats } from '../../context/LibraryStatsContext';
import { removeListener } from '../../helper/electron';
import './HealthReportPage.scss'; // Corrected import

const HealthReportPage: React.FC = () => {
  const history = useHistory();
  const { refreshStats } = useLibraryStats();
  const listenerRefs = useRef<{
    [key: string]: ((...args: any[]) => void) | undefined;
  }>({});

  useEffect(() => {
    return () => {
      Object.entries(listenerRefs.current).forEach(([eventName, listener]) => {
        removeListener(eventName, listener);
      });
      listenerRefs.current = {};
    };
  }, []);

  const handleSummaryComplete = () => {
    history.push('/my-library');
  };

  return (
    <IonPage id="health-report-page">
      <IonContent fullscreen>
        <div className="non-sticky-toolbar">
          <div className="custom-title-label">Library Health Report</div>
          <IonButton
            className="health-report-refresh-btn"
            onClick={() => {
              try {
                refreshStats();
              } catch (err) {
                console.error(
                  'Failed to refresh stats from Health Report',
                  err,
                );
              }
            }}
            title="Refresh stats"
            aria-label="Refresh stats"
          >
            <IonIcon
              icon={refreshOutline}
              slot="start"
              style={{ fontSize: '1.05rem', marginRight: '4px' }}
            />
            Refresh
          </IonButton>
        </div>
        <div className="ion-padding health-report-container">
          {/* We pass a dummy onComplete for now, or adjust LibrarySummaryStep prop requirements */}
          <LibrarySummaryStep onComplete={handleSummaryComplete} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HealthReportPage;
